import { All } from 'ui/svg/icons/venueAndCategories/All'
import { Book } from 'ui/svg/icons/venueAndCategories/Book'
import { Bookstore } from 'ui/svg/icons/venueAndCategories/Bookstore'
import { Brush as Workshop } from 'ui/svg/icons/venueAndCategories/Brush'
import { Card } from 'ui/svg/icons/venueAndCategories/Card'
import { Cinema } from 'ui/svg/icons/venueAndCategories/Cinema'
import { Disk } from 'ui/svg/icons/venueAndCategories/Disk'
import { FineArts } from 'ui/svg/icons/venueAndCategories/FineArts'
import { LiveEvent } from 'ui/svg/icons/venueAndCategories/LiveEvent'
import { Micro as Conference } from 'ui/svg/icons/venueAndCategories/Micro'
import { Microphone } from 'ui/svg/icons/venueAndCategories/Microphone'
import { Museum } from 'ui/svg/icons/venueAndCategories/Museum'
import { Music } from 'ui/svg/icons/venueAndCategories/Music'
import { Palette } from 'ui/svg/icons/venueAndCategories/Palette'
import { Piano as Instrument } from 'ui/svg/icons/venueAndCategories/Piano'
import { Press } from 'ui/svg/icons/venueAndCategories/Press'
import { Show } from 'ui/svg/icons/venueAndCategories/Show'
import { Streaming } from 'ui/svg/icons/venueAndCategories/Streaming'
import { Thing } from 'ui/svg/icons/venueAndCategories/Thing'
import { VideoGame } from 'ui/svg/icons/venueAndCategories/VideoGame'

export const categoriesIcons = {
  All,
  Book,
  Bookstore,
  Card,
  Cinema,
  Conference,
  Disk,
  FineArts,
  Instrument,
  LiveEvent,
  Microphone,
  Museum,
  Music,
  Palette,
  Press,
  Show,
  Streaming,
  Thing,
  VideoGame,
  Workshop,
}
